import { FC } from 'react';
import { Grid } from '@mui/material';
import Page, { PageProps } from '@/components/page';

import RecentPublicServices from '@/components/dashboard/RecentPublicServices';
import DashboardCard from '@/components/dashboard/DashboardCard';

const DashboardPage: FC<PageProps> = () => {
  return (
    <Page>
      <Grid container>
        <Grid container spacing={2} justifyContent="flex-start" m="auto" sm={12} md={8} lg={4}>
          <Grid item>
            <RecentPublicServices />
          </Grid>
        </Grid>
        <Grid
          container
          spacing={2}
          justifyContent="flex-start"
          alignContent="flex-start"
          m="auto"
          sm={12}
          md={4}
          lg={8}
        >
          <Grid item xs={12} sm={4} md={6}>
            <DashboardCard>Example</DashboardCard>
          </Grid>

          <Grid item xs={12} sm={4} md={6}>
            <DashboardCard>Example</DashboardCard>
          </Grid>
          <Grid item xs={12} sm={4} md={6}>
            <DashboardCard>Example</DashboardCard>
          </Grid>

          <Grid item xs={12} sm={12} md={6}>
            <DashboardCard>Example</DashboardCard>
          </Grid>
        </Grid>
      </Grid>
    </Page>
  );
};

export default DashboardPage;
